<div class="consolidate-view-wf-container">
  <div class="modal-body">
    <label>Consolidated View</label>
    <br />
    <br />
    <div>
      <table class="table table-bordered text custom-table">
        <thead style="text-align: center">
          <tr>
            <th>C/I</th>
            <th>LEID</th>
            <th>Rpt</th>
            <th>BSLA Business</th>
            <th>Feed Curr</th>
            <th>Legal Entity Name</th>
            <th>GAAP</th>
            <th>E&P Adjustments</th>
            <th>E&P</th>
            <th>Baseline Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (item of consolAmount; track $index) {
<tr>
            <td>{{ item.C_I }}</td>
            <td>{{ item.LE_ID }}</td>
            <td align="right">{{ item.TAX_CODE }}</td>
            <td align="right">{{ item.RPT_ID }}</td>
            <td align="right">{{ item.BSLA_BUSINESS }}</td>
            <td align="right">{{ item.FEED_CURR }}</td>
            <td align="right">{{ item.LEGAL_ENTITY_NAME }}</td>
            <td align="right">{{ item.GAAP }}</td>
            <td align="right">{{ item.E_P_ADJUSTMENT || item.E_PADJUSTMENT }}</td>
            <td align="right">{{ item.E_P }}</td>
            <td>{{ item.BASELINE_AMOUNT }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
</div>
